import React, { useEffect, useState } from "react";
import "./Food_and_wellness_journal.css";
import Green_round_btn from "../../common-components/common_btn/green_round_btn/Green_round_btn";
import { useDispatch, useSelector } from "react-redux";
import { getblog, getblogById } from "../../../features/blog/Slice";
import { Link } from "react-router-dom";
import Green_Outline_Btn from "../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import Blog_card from "../../blog/blog_card/Blog_card";

function Food_and_wellness_journal() {
  const blogData = useSelector((state) => state.blog.blog);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getblog());
  }, [dispatch]);

  return (
    <>
      {blogData && blogData?.data?.length > 0 ? (
        <section className="Food_and_wellness_journal">
          <div className="container-fluid">
            <div className="heading_holder">
              <h4 className="heading_text">Our Blogs</h4>
            </div>

            <div className="all_blogs_div">
              <div className="row">
                {blogData?.data?.slice(0, 3)?.map((blog) => (
                  <div className="col-lg-3 col-sm-6 mb-3">
                    <Blog_card
                      baseLink={`/blog-inner/${blog.id}`}
                      blogData={blog}
                    />
                  </div>
                ))}
              </div>
            </div>

          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
}

export default Food_and_wellness_journal;
